// dataService.js - Updated to use session-based authentication

import OdooSessionService from './sessionBasedOdooService';

// Initialize Odoo session service
const odooConfig = {
  url: 'https://mimir.xyz',
  db: 'production',
  login: "salasar.developer@icloud.com",
  password: "t4a39W5@3KnC" // Replace with your actual password
};
// console.log('🚀 Initializing Odoo service with config:', {
//   url: odooConfig.url,
//   db: odooConfig.db,
//   login: odooConfig.login
// });

 const odoo = new OdooSessionService(odooConfig);
export const fetchProductsFromOdoo = async () => {
  try {
    console.log('🛍️ Starting fetchProductsFromOdoo...');
    
    // First, let's test the connection
    const connectionTest = await odoo.testConnection();
             // console.log('🔍 Connection test result:', connectionTest);
    
    // Check auth status before starting
    const authStatus = odoo.getAuthStatus();
            // console.log('🔐 Auth status before fetch:', authStatus);
    
            // Fetch products using the class method
            // console.log('📦 Calling odoo.fetchProducts()...');
    const products = await odoo.fetchProducts();
    
    // console.log('📊 Products received from odoo.fetchProducts():');
    // console.log('   Type:', typeof products);
    // console.log('   Is Array:', Array.isArray(products));
    // console.log('   Content:', products);
    
    // Handle different response formats
    let productList = [];
    
    if (Array.isArray(products)) {
        // console.log('✅ Products is already an array with length:', products.length);
      productList = products;
    } else if (products && products.result && Array.isArray(products.result)) {
          // console.log('✅ Found products in .result property, length:', products.result.length);
      productList = products.result;
    } else if (products && products.records && Array.isArray(products.records)) {
          // console.log('✅ Found products in .records property, length:', products.records.length);
      productList = products.records;
    } else if (products && Array.isArray(products.products)) {
          // console.log('✅ Found products in .products property, length:', products.products.length);
      productList = products.products;
    } else if (products && products.data && Array.isArray(products.data)) {
          // console.log('✅ Found products in .data property, length:', products.data.length);
      productList = products.data;
    } else if (products && typeof products === 'object') {
            // console.log('⚠️ Products is an object, wrapping in array');
            // console.log('   Object keys:', Object.keys(products));
      productList = [products];
    } else {
            console.warn('⚠️ Unexpected products format:', products);
      productList = [];
    }
    
    console.log('📋 Processing product list with', productList.length, 'items');
    
    if (productList.length > 0) {
      // console.log('🔍 Sample product structure (first item):');
      console.log('   Keys:', Object.keys(productList[0]));
      // console.log('   Sample:', JSON.stringify(productList[0], null, 2));
    }
    
    // Transform products to consistent format
    const transformedProducts = productList.map((product, index) => {
        // console.log(`🔄 Transforming product ${index + 1}:`, {
        //   id: product.id,
        //   name: product.name || product.display_name,
        //   price: product.list_price || product.price || product.standard_price
        // });
      
      return {
        id: product.id,
        name: product.name || product.display_name || 'Unnamed Product',
        price: parseFloat(product.list_price || product.price || product.standard_price || 0),
        category: product.categ_id ? 
          (Array.isArray(product.categ_id) ? product.categ_id[1] : product.categ_id) : 
          'Uncategorized',
        description: product.description_sale || product.description || '',
        image: product.image_1920 || product.image_medium || null,
        available: product.qty_available || 0,
        barcode: product.barcode || null
      };
    });

    // console.log(`✅ Successfully transformed ${transformedProducts.length} products`);
    // console.log('🎉 Final products array:', transformedProducts);
    
    return transformedProducts;

  } catch (error) {
    console.error('💥 Error in fetchProductsFromOdoo:', error);
    console.error('📊 Error details:');
    console.error('   Message:', error.message);
    console.error('   Stack:', error.stack);
    
    // Handle different types of errors
    if (error.message.includes('401') || 
        error.message.includes('authentication') ||
        error.message.includes('Unauthorized')) {
      console.log('🔄 Authentication error detected, resetting auth state');
      odoo.isAuthenticated = false;
    }
    
    if (error.message.includes('Failed to fetch') || error.message.includes('TypeError')) {
      console.error('🌐 Network error - check server connectivity');
    }
    
    if (error.message.includes('404')) {
      console.error('🔍 Endpoint not found - check URL: /my_library/productsjson');
    }
    
    // Return empty array for graceful degradation
    console.log('📦 Returning empty array due to error');
    return [];
  }
};

export const getSessionInfo = async () => {
  try {
            // console.log('📋 Getting session info...');
    const sessionInfo = await odoo.getSessionInfo();
              // console.log('✅ Session info retrieved successfully:', sessionInfo);
    return sessionInfo;
  } catch (error) {
    console.error('💥 Error getting session info:', error);
    throw error;
  }
};

export const testAuthentication = async () => {
  try {
            // console.log('🔐 Testing authentication...');
    
    // Check current auth status
    const authStatus = odoo.getAuthStatus();
          // console.log('📊 Current auth status:', authStatus);
    
    const isAuth = await odoo.authenticate();
            // console.log('✅ Authentication test result:', isAuth);
    
    // Check auth status after
    const newAuthStatus = odoo.getAuthStatus();
            // console.log('📊 New auth status:', newAuthStatus);
    
    return isAuth;
  } catch (error) {
    console.error('💥 Authentication test failed:', error);
    
    if (error.message.includes('Failed to fetch')) {
      throw new Error('Network error: Cannot reach Odoo server at https://mimir.xyz');
    } else if (error.message.includes('401') || error.message.includes('Authentication failed')) {
      throw new Error('Authentication failed: Invalid credentials.');
    } else {
      throw new Error(`Authentication error: ${error.message}`);
    }
  }
};

export const fetchFromCustomEndpoint = async (endpoint) => {
  try {
          // console.log(`🌐 Fetching from custom endpoint: ${endpoint}`);
    const result = await odoo.makeAuthenticatedRequest(endpoint);
          // console.log(`✅ Successfully fetched from ${endpoint}:`, result);
    return result;
  } catch (error) {
    console.error(`💥 Error fetching from ${endpoint}:`, error);
    
    if (error.message.includes('Failed to fetch')) {
      throw new Error(`Network error accessing ${endpoint}`);
    }
    
    throw error;
  }
};

export const testConnection = async () => {
  try {
          // console.log('🔍 Testing basic connection to Odoo server...');
    const result = await odoo.testConnection();
          // console.log('✅ Connection test result:', result);
    return result;
  } catch (error) {
    console.error('💥 Connection test failed:', error);
    return false;
  }
};

export const isOdooServiceReady = () => {
  const ready = odoo && typeof odoo.authenticate === 'function';
        // console.log('🔍 Odoo service ready check:', ready);
  return ready;
};

export const logoutFromOdoo = async () => {
  try {
          // console.log('🚪 Logging out from Odoo...');
    const result = await odoo.logout();
          // console.log('✅ Logout result:', result);
    return result;
  } catch (error) {
    console.error('💥 Error during logout:', error);
    return false;
  }
};

// Debug helper to check what's happening
export const debugOdooState = () => {
  const state = {
    serviceExists: !!odoo,
    authStatus: odoo ? odoo.getAuthStatus() : null,
    config: odooConfig
  };
  console.log('🐛 Debug Odoo State:', state);
  return state;
};

 ////////////////////////////////////////////////////////////// version 2 below
// export const fetchProductsFromOdoo = async () => {
//   try {
//     console.log('Fetching products from Odoo via JSON-RPC...');
    
//     // Ensure authentication before making requests
//     const isAuthenticated = await odoo.authenticate();
//     if (!isAuthenticated) {
//       throw new Error('Failed to authenticate with Odoo');
//     }
    
//     // Fetch products using the JSON-RPC endpoint
//     const products = await odoo.fetchProducts();
    
//     console.log('Raw products response:', products);
    
//     // Handle different response formats from Odoo JSON-RPC
//     let productList = [];
    
//     if (Array.isArray(products)) {
//       productList = products;
//     } else if (products && products.result && Array.isArray(products.result)) {
//       productList = products.result;
//     } else if (products && products.records && Array.isArray(products.records)) {
//       productList = products.records;
//     } else if (products && Array.isArray(products.products)) {
//       productList = products.products;
//     } else if (products && typeof products === 'object') {
//       // If it's a single product object, wrap it in an array
//       productList = [products];
//     }
    
//     console.log('Processed product list:', productList);
    
//     // Transform products to consistent format
//     return productList.map(product => ({
//       id: product.id,
//       name: product.name || product.display_name || 'Unnamed Product',
//       price: parseFloat(product.list_price || product.price || product.standard_price || 0),
//       category: product.categ_id ? 
//         (Array.isArray(product.categ_id) ? product.categ_id[1] : product.categ_id) : 
//         'Uncategorized',
//       description: product.description_sale || product.description || '',
//       image: product.image_1920 || product.image_medium || null,
//       available: product.qty_available || 0,
//       barcode: product.barcode || null
//     }));

//   } catch (error) {
//     console.error('Error fetching products from Odoo:', error);
    
//     // Handle authentication errors
//     if (error.message.includes('401') || 
//         error.message.includes('authentication') ||
//         error.message.includes('session_id')) {
//       console.log('Authentication error detected, clearing session...');
//       odoo.clearSession();
//     }
    
//     // Handle network errors
//     if (error.message.includes('Failed to fetch') || error.message.includes('TypeError')) {
//       console.error('Network error - check if Odoo server is accessible');
//     }
    
//     // Return empty array for graceful degradation
//     return [];
//   }
// };

// // Function to get session information
// export const getSessionInfo = async () => {
//   try {
//     const sessionInfo = await odoo.getSessionInfo();
//     console.log('Session info retrieved:', sessionInfo);
//     return sessionInfo;
//   } catch (error) {
//     console.error('Error getting session info:', error);
//     throw error;
//   }
// };

// // Test authentication function - this might be causing your original error
// export const testAuthentication = async () => {
//   try {
//     console.log('Testing authentication...');
//     const isAuth = await odoo.authenticate();
//     console.log('Authentication test result:', isAuth);
//     return isAuth;
//   } catch (error) {
//     console.error('Authentication test failed:', error);
    
//     // Provide more specific error information
//     if (error.message.includes('Failed to fetch')) {
//       throw new Error('Network error: Cannot reach Odoo server. Check URL and connectivity.');
//     } else if (error.message.includes('401')) {
//       throw new Error('Authentication failed: Invalid credentials or expired session.');
//     } else {
//       throw new Error(`Authentication error: ${error.message}`);
//     }
//   }
// };

// // Function to make authenticated JSON-RPC calls
// export const callOdooMethod = async (model, method, args = [], kwargs = {}) => {
//   try {
//     console.log(`Calling Odoo method: ${model}.${method}`);
    
//     const isAuthenticated = await odoo.authenticate();
//     if (!isAuthenticated) {
//       throw new Error('Authentication required');
//     }
    
//     const result = await odoo.call(model, method, args, kwargs);
//     console.log(`Method call result:`, result);
//     return result;
    
//   } catch (error) {
//     console.error(`Error calling ${model}.${method}:`, error);
//     throw error;
//   }
// };

// // Function to search and read records
// export const searchRead = async (model, domain = [], fields = [], options = {}) => {
//   try {
//     console.log(`Searching ${model} with domain:`, domain);
    
//     const isAuthenticated = await odoo.authenticate();
//     if (!isAuthenticated) {
//       throw new Error('Authentication required');
//     }
    
//     const result = await odoo.searchRead(model, domain, fields, options);
//     console.log(`Search read result:`, result);
//     return result;
    
//   } catch (error) {
//     console.error(`Error in search_read for ${model}:`, error);
//     throw error;
//   }
// };

// // Generic function to fetch from custom endpoints
// export const fetchFromCustomEndpoint = async (endpoint) => {
//   try {
//     console.log(`Fetching from custom endpoint: ${endpoint}`);
    
//     const isAuthenticated = await odoo.authenticate();
//     if (!isAuthenticated) {
//       throw new Error('Authentication required');
//     }
    
//     return await odoo.makeAuthenticatedRequest(endpoint);
    
//   } catch (error) {
//     console.error(`Error fetching from ${endpoint}:`, error);
    
//     if (error.message.includes('Failed to fetch')) {
//       throw new Error(`Network error accessing ${endpoint}`);
//     }
    
//     throw error;
//   }
// };

// // Helper function to check if Odoo service is ready
// export const isOdooServiceReady = () => {
//   return odoo && typeof odoo.authenticate === 'function';
// };

// // Function to manually clear session (useful for logout)
// export const clearOdooSession = () => {
//   try {
//     odoo.clearSession();
//     console.log('Odoo session cleared');
//   } catch (error) {
//     console.error('Error clearing session:', error);
//   }
// };


///////////////////////////////////////////////////////// version 1 below

// export const fetchProductsFromOdoo = async () => {
//   try {
//     console.log('Fetching products from Odoo via custom endpoint...');
    
//     // Fetch products from your custom endpoint
//     const products = await odoo.fetchProducts();
    
//     // The products might already be in the format you need,
//     // but let's handle different possible formats
    
//     // If products is already an array, use it directly
//     if (Array.isArray(products)) {
//       console.log('Products received as array:', products);
//       return products.map(product => ({
//         id: product.id,
//         name: product.name || 'Unnamed Product',
//         price: product.price || product.list_price || 0,
//         category: product.category || product.categ_id || 'Uncategorized'
//       }));
//     }
    
//     // If products has a result property (JSON-RPC response)
//     if (products.result && Array.isArray(products.result)) {
//       console.log('Products received in result property:', products.result);
//       return products.result.map(product => ({
//         id: product.id,
//         name: product.name || 'Unnamed Product',
//         price: product.price || product.list_price || 0,
//         category: product.category || product.categ_id || 'Uncategorized'
//       }));
//     }
    
//     // If products is a single object with products property
//     if (products.products && Array.isArray(products.products)) {
//       console.log('Products received in products property:', products.products);
//       return products.products.map(product => ({
//         id: product.id,
//         name: product.name || 'Unnamed Product',
//         price: product.price || product.list_price || 0,
//         category: product.category || product.categ_id || 'Uncategorized'
//       }));
//     }
    
//     // Log the actual structure to help debug
//     console.log('Unexpected products structure:', products);
//     console.log('Type of products:', typeof products);
//     console.log('Products keys:', Object.keys(products));
    
//     // Return empty array if we can't parse the structure
//     return [];

//   } catch (error) {
//     console.error('Error fetching products from Odoo:', error);
    
//     // Check if it's an authentication error
//     if (error.message.includes('401') || error.message.includes('authentication')) {
//       console.log('Authentication may have expired, will retry on next request');
//       odoo.isAuthenticated = false;
//     }
    
//     // Return empty array for graceful degradation
//     return [];
    
//     // Or re-throw if you want useDataSync to handle the error
//     // throw error;
//   }
// };

// // Test function to check session info
// export const getSessionInfo = async () => {
//   try {
//     return await odoo.getSessionInfo();
//   } catch (error) {
//     console.error('Error getting session info:', error);
//     throw error;
//   }
// };

// // Test function to check authentication
// export const testAuthentication = async () => {
//   try {
//     const isAuth = await odoo.authenticate();
//     console.log('Authentication test result:', isAuth);
//     return isAuth;
//   } catch (error) {
//     console.error('Authentication test failed:', error);
//     throw error;
//   }
// };

// // Generic function to fetch from any custom endpoint
// export const fetchFromCustomEndpoint = async (endpoint) => {
//   try {
//     return await odoo.makeAuthenticatedRequest(endpoint);
//   } catch (error) {
//     console.error(`Error fetching from ${endpoint}:`, error);
//     throw error;
//   }
// };